import { Injectable } from '@angular/core';
import { UrlProperties } from '../../models/Core.model';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
    providedIn: 'root'
})

export class NavigationService {

    public processUrl(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): UrlProperties {
        const entirePath = state.url.split('?')[0];

        let outletsString: string, hasOutlet: boolean, outletsObject: object;
        if (state.url.split('(')[1]) {
            outletsString = `(${state.url.split('(')[1].split(')')[0]})`;
            outletsObject = {
                container: state.url.split('(')[1].split(':')[0],
                value: state.url.split('(')[1].split(':')[1].split(')')[0]
            };
            hasOutlet = true;
        } else {
            outletsString = '';
            hasOutlet = false;
            outletsObject = {};
        }

        const _getUrlSegments = (path: string) => {
            const segments = [];
            const splittedPath = path.split('/');
            for (let i = 1; i < splittedPath.length; i++) {
                segments.push(splittedPath[i]);
            }
            return segments;
        };

        return {
            fullUrl: state.url,
            queryString: state.url.split('?')[1],
            queryObject: route.queryParams,
            pathPieces: _getUrlSegments(entirePath),
            urlParams: route.params,
            entirePath,
            outletsObject,
            outletsString,
            hasOutlet
        };
    }

}